import { React } from 'react'
import classNames from 'classnames'
import { Button, Checkbox } from 'antd'

import { COLORS } from 'pages/records/components/RecordLabel/color'

import styles from 'pages/records/components/style.module.scss'
import pencilIcon from '@/assets/images/icon-pencil-24.svg'
import trashIcon from '@/assets/images/icon-trash-24-dark-gray.svg'

// import defaultIcon from '@/assets/images/defaultRecordIcon.png'

const FolderLabelIcon = ({ color = '#000' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4674 13.8944L13.9007 20.4627C13.5571 20.8067 13.0909 21 12.6047 21C12.1186 21 11.6524 20.8067 11.3088 20.4627L3.44163 12.6027C2.60811 8.71479 2.95446 6.00755 4.48069 4.48095C6.00691 2.95434 8.7134 2.60799 12.6002 3.44189L20.4674 11.311C21.1775 12.0256 21.1775 13.1797 20.4674 13.8944Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.021 8.02229H8.03015"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const getTableInfo = (handleDeleteLabel, selectedKeys, setSelectedKeys, setOpen, setId) => {
  const onRow = (record) => {
    return {
      onClick: (e) => {
        if (
          e.target.type === 'checkbox' ||
          e.target.closest('.ant-btn') ||
          e.target.closest('.ant-checkbox-wrapper')
        ) {
          return
        }

        let newSelectedKeys = [...selectedKeys]

        if (newSelectedKeys.includes(record.key)) {
          newSelectedKeys = newSelectedKeys.filter((key) => key !== record.key)
        } else {
          newSelectedKeys = [...newSelectedKeys, record.key]
        }

        setSelectedKeys(newSelectedKeys)
      },
    }
  }

  const columns = (isManageMode = false) => [
    {
      dataIndex: 'icon',
      key: 'icon',
      width: 32,
      render: (_, label) => {
        return (
          <FolderLabelIcon color={COLORS.find((color) => color.value === label.color)?.color} />
        )
      },
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (_, label) => {
        return <div className={classNames(styles.AppTitle)}>{label.name}</div>
      },
    },
    isManageMode
      ? {
          key: 'actions',
          width: 120,
          render: (_, label) => {
            const { key, color } = label

            return (
              <div
                style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}
                className={classNames(styles.actionBtn)}
              >
                <Button
                  type="text"
                  icon={<img src={pencilIcon} alt="pencil" />}
                  onClick={() => {
                    setOpen(true)
                    setId(key)
                  }}
                />
                <Button
                  type="text"
                  icon={<img src={trashIcon} alt="trash" />}
                  onClick={() => handleDeleteLabel(key, color)}
                />
              </div>
            )
          },
        }
      : {
          key: 'selection',
          width: 48,
          render: (_, record) => {
            const { key } = record
            const isSelected = selectedKeys && selectedKeys.includes(key)

            return (
              <Checkbox
                checked={isSelected}
                onChange={(e) => {
                  e.stopPropagation()
                  const { checked } = e.target

                  let newSelectedKeys = [...(selectedKeys || [])]

                  if (checked) {
                    if (!newSelectedKeys.includes(key)) {
                      newSelectedKeys = [...newSelectedKeys, key]
                    }
                  } else {
                    newSelectedKeys = newSelectedKeys.filter((k) => k !== key)
                  }

                  setSelectedKeys(newSelectedKeys)
                }}
              />
            )
          },
        },
  ]

  return { columns, onRow }
}

export default getTableInfo
